import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowAllowedEstablishmentsProps<T> = {
  workflowId?: string
  filters?: {
    search?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useMaintenanceWorkflowAllowedEstablishments = <T,>({
  workflowId,
  filters: { search = '', page = 1 } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceWorkflowAllowedEstablishmentsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    enabled: !!workflowId,
    queryKey: ['maintenanceWorkflowAllowedEstablishments', workflowId, search, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/workflows/${workflowId}/allowed_establishments`, {
        params: {
          search,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
